/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import SocialActivityAction from 'components/SocialActivityAction';
import PostHeader from 'components/PostHeader';
import PostDescription from 'components/PostDescription';
import ImageSliderFeed from 'containers/ImageSliderFeed';
import appState from 'hooks/appState';
import { APP_STATE } from 'types';

import SocialActivity from 'components/SocialActivity';
import useSingleAndDoubleClick from 'hooks/useSingleAndDoubleClick';
import getMaxString from 'utils/getMaxString';
import { useState } from 'react';
import { IPostDiscussionPhotoPost } from './IPostPageDiscussionPost';

import {
  PostPagePhotoPostWrapper,
  SocialActivityBlock,
} from './PostPageDiscussionPost.styles';

const PostPagePhotoPost = ({
  title,
  profilePhoto,
  userId,
  creatorId,
  username,
  fullname,
  isVerified,
  isAmbassador,
  isDonor,
  isMe,
  followingStatus,
  postTime,
  mediaObjects,
  origin,
  users,
  groups,
  events,
  text,
  locationName,
  isLike,
  likes,
  id,
  originId,
  commentsCount,
  sharesCount,
  data,
  geoLocation,
  onCommentClick,
  onLikesCountClick,
  onLikeClick,
}: IPostDiscussionPhotoPost) => {
  console.log(id);
  const [isPagePhotoUrlCopied, setIsPagePhotoUrlCopied] =
    useState<boolean>(false);

  const appStateAction = appState();

  const handleOnPhoto = useSingleAndDoubleClick(
    () => {
      if (mediaObjects[0]?.videoUrl) {
        return;
      }
      appStateAction(APP_STATE.EXPAND_IMAGES_TOGGLE, {
        isOpen: true,
        data,
      });
    },
    () => {
      onLikeClick(id);
    }
  );
  return (
    <PostPagePhotoPostWrapper>
      <PostHeader
        profilePhoto={profilePhoto}
        userId={userId}
        username={username}
        fullname={fullname}
        creatorId={creatorId}
        isVerified={isVerified}
        isAmbassador={isAmbassador}
        isDonor={isDonor}
        isMe={isMe}
        followingStatus={followingStatus}
        postTime={postTime}
        type={11}
        id={id}
        origin={origin}
        originId={originId}
        data={data}
      />
      {text?.trim()?.length > 0 && (
        <PostDescription
          origin={origin}
          users={users}
          groups={groups}
          events={events}
          text={text}
          locationName={locationName}
          type={11}
          geoLocation={geoLocation}
          title={title}
        />
      )}
      <div onClick={handleOnPhoto}>
        <ImageSliderFeed images={mediaObjects} alt={getMaxString(text, 8)} />
      </div>
      <SocialActivityBlock>
        <SocialActivity
          id={id}
          onCommentClick={(id) => onCommentClick(id)}
          onLikeClick={onLikeClick}
          onLikesCountClick={(id) => onLikesCountClick(id)}
          commentsNumber={commentsCount}
          sharesNumber={sharesCount}
          likesNumber={likes}
          isLike={isLike}
          type="post"
          postType={1}
          isUrlCopied={isPagePhotoUrlCopied}
          setIsUrlCopied={setIsPagePhotoUrlCopied}
        />
      </SocialActivityBlock>
    </PostPagePhotoPostWrapper>
  );
};

export default PostPagePhotoPost;
